import { createContext, useState } from "react";

export const OrderOffersContext = createContext({});
export const OrderOfferProvider = ({ children }) => {
  const [orderOffersContext, setOrderOffersContext] = useState({});
  const value = { orderOffersContext, setOrderOffersContext };
  return (
    <OrderOffersContext.Provider value={value}>
      {children}
    </OrderOffersContext.Provider>
  );
};
